import { render, staticRenderFns } from "./ManageENSContainer.vue?vue&type=template&id=09df312a&scoped=true&"
import script from "./ManageENSContainer.vue?vue&type=script&lang=js&"
export * from "./ManageENSContainer.vue?vue&type=script&lang=js&"
import style0 from "./ManageENSContainer.vue?vue&type=style&index=0&id=09df312a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09df312a",
  null
  
)

export default component.exports